module.exports = __webpack_public_path__ + "img/xj(1).f603299b.png";